module.exports =
  base: '/order/v2'
  integrations:
    walmart:
      configurator: '/order/v2/integrations/walmart/configurator'
    util:
      crop: '/order/v2/integrations/util/crop'
      fit: '/order/v2/integrations/util/fit'
  cart:
    base: '/order/v2/cart'
    detail: '/order/v2/cart/:cartId'
    checkout:
      base: '/order/v2/cart/:cartId/checkout'
      quantity: '/order/v2/cart/:cartId/checkout/quantity'
      shippingMethod: '/order/v2/cart/:cartId/checkout/shippingMethod'
      review: '/order/v2/cart/:cartId/checkout/review'
    confirmation:
      base: '/order/v2/cart/:cartId/confirmation'
    printable:
      base: '/order/v2/cart/:cartId/printable'
      detail: '/order/v2/cart/:cartId/printable/:printableId'
      family: '/order/v2/cart/:cartId/printable/:printableId/family'
      category: '/order/v2/cart/:cartId/printable/:printableId/category'
      design: '/order/v2/cart/:cartId/printable/:printableId/design'
    fromOrder: '/order/v2/cart/:orderId/fromOrder'
  mockup:
    design: '/order/v2/mockup/design'

  data:
    mockup:
      email: '/order/v2/data/mockup/email' # Create mockup and email
      design: '/order/v2/data/mockup/:designId/design.png' # Create mockup URI
    cart:
      base: '/order/v2/data/cart'
      detail: '/order/v2/data/cart/:cartId'
      address:
        base: '/order/v2/data/cart/:cartId/address'
        update: '/order/v2/data/cart/:cartId/address/update'
      share: '/order/v2/data/cart/:cartId/share'
      place: '/order/v2/data/cart/:cartId/place'
      quote: '/order/v2/data/cart/:cartId/quote'
      finalize: '/order/v2/data/cart/:cartId/finalize'
    csv:
      template: '/order/v2/data/csv/template'
      upload: '/order/v2/data/csv/:cartId/upload'
    shippingMethod:
      base: '/order/v2/data/shippingMethod'
    address:
      base: '/order/v2/data/address'
      validate: '/order/v2/data/address/validate'
      save: '/order/v2/data/:userId/address/save'
      bulk: '/order/v2/data/:userId/address/bulk'

    order:
      detail: '/order/v2/data/order/:orderId'
    dystar:
      detail: '/order/v2/data/dystar'
    design:
      bulk: '/order/v2/data/design/bulk'
      accessory: '/order/v2/data/design/accessory'
      artwork: '/order/v2/data/design/artwork'
      search: '/order/v2/data/design/search'
      name:
        design : '/order/v2/data/design/name/design'
        artwork: '/order/v2/data/design/name/artwork'
      embr:
        colors: '/order/v2/data/design/embr/colors'
    product:
      base: '/order/v2/data/product'
      truckable: '/order/v2/data/product/:identifier/truckable'
      prices: '/order/v2/data/product/:identifier/prices'

  billing:
    balance: '/order/v2/data/billing/:billingId/balance'


  shipping: '/order/v2/data/shipping' # get shipping prices

  proxy:
    router:
      sla:
        product: '/order/v2/proxy/router/sla/product/:productIdentifier'
        productDetailed: '/order/v2/proxy/router/sla/productDetailed/:productIdentifier'
        productItemBulk: '/order/v2/proxy/router/sla/productItemBulk'
      order:
        base: '/order/v2/proxy/router/order'
    shipping:
      times: '/order/v2/proxy/shipping/times'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/order2.coffee